import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { of } from '@polkadot/x-rxjs';
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
import { didUpdateToBool } from "./util.mjs";

function parseActive(id, active) {
  var found = active.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        paraId = _ref2[0];

    return paraId === id;
  });

  if (found && found[1].isSome) {
    var _found$1$unwrap = found[1].unwrap(),
        _found$1$unwrap2 = _slicedToArray(_found$1$unwrap, 2),
        collatorId = _found$1$unwrap2[0],
        retriable = _found$1$unwrap2[1];

    return _objectSpread({
      collatorId: collatorId
    }, retriable.isWithRetries ? {
      isRetriable: true,
      retries: retriable.asWithRetries.toNumber()
    } : {
      isRetriable: false,
      retries: 0
    });
  }

  return null;
}

function parseCollators(id, collatorQueue) {
  return collatorQueue.map(function (queue) {
    var found = queue.find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          paraId = _ref4[0];

      return paraId === id;
    });
    return found ? found[1] : null;
  });
}

function parse(id, _ref5) {
  var _ref6 = _slicedToArray(_ref5, 8),
      active = _ref6[0],
      retryQueue = _ref6[1],
      selectedThreads = _ref6[2],
      didUpdate = _ref6[3],
      info = _ref6[4],
      pendingSwap = _ref6[5],
      heads = _ref6[6],
      relayDispatchQueue = _ref6[7];

  if (info.isNone) {
    return null;
  }

  return {
    active: parseActive(id, active),
    didUpdate: didUpdateToBool(didUpdate, id),
    heads: heads,
    id: id,
    info: _objectSpread({
      id: id
    }, info.unwrap()),
    pendingSwapId: pendingSwap.unwrapOr(null),
    relayDispatchQueue: relayDispatchQueue,
    retryCollators: parseCollators(id, retryQueue),
    selectedCollators: parseCollators(id, selectedThreads)
  };
}

export function info(instanceId, api) {
  return memo(instanceId, function (id) {
    return api.query.registrar && api.query.parachains ? api.queryMulti([api.query.registrar.active, api.query.registrar.retryQueue, api.query.registrar.selectedThreads, api.query.parachains.didUpdate, [api.query.registrar.paras, id], [api.query.registrar.pendingSwap, id], [api.query.parachains.heads, id], [api.query.parachains.relayDispatchQueue, id]]).pipe(map(function (result) {
      return parse(api.registry.createType('ParaId', id), result);
    })) : of(null);
  });
}